export default "__VITE_ASSET__M_vO3ryx__"